import { myAxios } from "../../utils/serverContextPath";

import { jwtDecode } from "jwt-decode";



export function registerAPICall(data) {
  return myAxios.post(
    "/userapp/register",
    data
  );
}

export function firebaseLoginAPICall(data) {
  return myAxios.post(
    "/userapp/firebase-login",
    data
  );
}

export function loginAPICall(email, password) {
  return myAxios.post(
    "/userapp/login",
    {
      email,
      password,
    }
  );
}

export function storeToken(token) {
  localStorage.setItem("token", token);
}

export function getToken() {
  return localStorage.getItem("token");
}

export function saveLoggedInUser(user) {
  localStorage.setItem(
    "user",
    JSON.stringify(user)
  );
}

export function getLoggedInUser() {
  const user =
    localStorage.getItem("user");

  return user
    ? JSON.parse(user)
    : null;
}

export function isUserLoggedIn() {
  return localStorage.getItem("token")
    !== null;
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  window.location.href = "/";
}

export function decodeToken() {

  const token = getToken();

  if (!token) {
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error(
      "Erreur décodage JWT",
      error
    );

    return null;
  }
}

export function getUserRole() {

  const decoded =
      decodeToken();

  if (!decoded) {
    return null;
  }

  return decoded.role;
}


export const updateUserApp = (data) => {
  return myAxios.post("userapp/save/update", data);
};

export const getUserAppById = (id) => {
  return myAxios.get(`userapp/getbyid/${id}`);
};

export const updateLangue = (id, lang) => {
    return myAxios.post(`userapp/langue/${id}/${lang}`);
};

export const getUserAppAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("userapp/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllUserApp = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("userapp/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const deleteUserApp = (id) => {
  return myAxios.delete(`userapp/delete/${id}`);
};

export const postUserApp = (data) => {
  return myAxios.post("userapp/save/insert", data);
};


export const findSimilarUserApp = (
  keyword,
  tauxsimilarity = 0.6,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("userapp/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });
};



export const getAllConsultantPage = (

    keyword,
    tauxsimilarity = 0.6,
    natureActivityType,
    idSpecialites,
    idActivityProfs,
    idwilaya,
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"

) => {

    return myAxios.get(
        "userapp/getallconsultantpage",
        {
            params: {
                keyword,
                tauxsimilarity,
                natureActivityType,
                idSpecialites:
                    idSpecialites && idSpecialites.length
                        ? idSpecialites.join(",")
                        : "",

                idActivityProfs:
                    idActivityProfs && idActivityProfs.length
                        ? idActivityProfs.join(",")
                        : "",
                idwilaya,
                page: pageNumber,
                size: itemsPerPage,
                sortList,
                sortOrder

            }

        }

    );

};


export const updatePhotoUserApp = (id, formData) => {
    return myAxios.post(
        `userapp/uploadprofile/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const downloadPhotoUserApp = (id) => {
    return myAxios.get(`userapp/downloadprofile/${id}`, {
        responseType: "blob",
    });

};

export const addSpecialiteToUser = (uid, sid) => {
    return myAxios.post(`/userapp/addspecialite/${uid}/${sid}` );
};

export const removeSpecialiteFromUser = (uid, sid) => {
    return myAxios.post(`/userapp/removespecialite/${uid}/${sid}` );
};

  

export const addActivityProfToUser = (uid,apid) => {
  return myAxios.post(`/userapp/addactivityprof/${uid}/${apid}` );
};

export const removeActivityProfFromUser = (uid,apid) => {
  return myAxios.post(`userapp/removeactivityprof/${uid}/${apid}` );
};   


export const addActivityTypeToUser = (uid,atid) => {
  return myAxios.post(`userapp/addactivitytype/${uid}/${atid}` );
};

export const removeActivityTypeFromUser = (uid,atid) => {
  return myAxios.post(`userapp/removeactivitytype/${uid}/${atid}` );
};   


//Securite

// ============================================================
// ROLES
// ============================================================

export const getAllRole = () => {
    return myAxios.get("role/getall");
};


// ============================================================
// AJOUTER UN ROLE A UN UTILISATEUR
// ============================================================

export const addRoleToUser = (email, roleName) => {

    return myAxios.post(
        "userapp/addroletouser",
        null,
        {
            params: {
                email,
                roleName
            }
        }
    );
};


// ============================================================
// SUPPRIMER UN ROLE D'UN UTILISATEUR
// ============================================================

export const removeRoleFromUser = (
    email,
    roleName
) => {

    return myAxios.post(
        "userapp/removerolefromuser",
        null,
        {
            params: {
                email,
                roleName
            }
        }
    );
};


export const hasRole = (roleName) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.roles) {
        return false;
    }
    return user.roles.some(role => role.roleName === roleName);

};


/**
 * ============================================================
 * NOMBRE D'UTILISATEURS PAR PROFIL ET NATURE D'ACTIVITE
 * ============================================================
 *
 * fp   = P -> Professionnel / Consultant
 * fp   = F -> Felah
 *
 * nact = C -> Agriculture
 * nact = L -> Elevage
 *
 */
export const countByNatureActivityType = (fp, nact) => {

    return myAxios.get(
        "userapp/countbynatureactivitytype",
        {
            params: {
                fp,
                nact
            }
        }
    );
};


/**
 * ============================================================
 * NOMBRE DE SPECIALITES
 * ============================================================
 *
 * nact = C -> Agriculture
 * nact = L -> Elevage
 *
 */
export const countSpecialitesByNatureActivityType = (nact) => {

    return myAxios.get(
        "userapp/countspecialitesbynatureactivitytype",
        {
            params: {
                nact
            }
        }
    );
};


/**
 * ============================================================
 * NOMBRE D'ACTIVITES PROFESSIONNELLES
 * ============================================================
 *
 * nact = C -> Agriculture
 * nact = L -> Elevage
 *
 */
export const countActivityProfsByNatureActivityType = (nact) => {

    return myAxios.get(
        "userapp/countactivityprofsbynatureactivitytype",
        {
            params: {
                nact
            }
        }
    );
};


export const countActivityTypesByFelah = (nact) => {

    return myAxios.get(
        "userapp/countactivitytypesbyfelah",
        {
            params: {
                nact
            }
        }
    );
};